<template>
	<div class="mt-auto">
		<span v-if="Boolean(selectedPlace) && selectedPlace.typeDocuments.length" class="text-left">
			<v-btn
				v-if="
					selectedPlace.documents.some(item => {
						if (item && item.date) return itsDue(item.date);
					})
				"
				color="secondary"
				class="ma-2 elevation-0"
				x-small
				outlined
				to="documents"
			>
				<v-icon left color="warning">mdi-clock-alert</v-icon>
				<span>Algun documento ha caducado</span>
			</v-btn>
			<template v-else>
				<v-btn
					v-if="
						Array.isArray(selectedPlace.documents) &&
							!selectedPlace.documents.length &&
							Array.isArray(selectedPlace.typeDocuments) &&
							selectedPlace.typeDocuments.length
					"
					x-small
					outlined
					to="documents"
					color="secondary"
					class="ma-2 elevation-0"
				>
					<v-icon color="error" left> mdi-alert-circle</v-icon>
					No ha subido documentos
				</v-btn>
				<template v-else>
					<template
						v-if="
							Array.isArray(selectedPlace.typeDocuments) &&
								selectedPlace.typeDocuments.length &&
								selectedPlace.typeDocuments.some(typeDocument => typeDocument)
						"
					>
						<v-btn
							v-if="
								selectedPlace.typeDocuments.some(
									doc => doc !== null && doc.done === false
								)
							"
							text
							to="documents"
							x-small
							class="my-2 caption"
						>
							<v-icon left small color="warning">mdi-file-question</v-icon>
							Establecimiento no verificado
							<span v-if="$vuetify.breakpoint.lgAndUp">
								, tiene documentos pendientes
							</span>
						</v-btn>
						<v-btn v-else to="documents" text x-small class="my-2 caption">
							<v-icon left small color="success">mdi-checkbox-marked-circle</v-icon>
							Establecimiento verificado
							<span v-if="$vuetify.breakpoint.lgAndUp">
								, todos sus documentos al dia
							</span>
						</v-btn>
					</template>
				</template>
			</template>
		</span>
		<!--export pdf-->
		<v-tooltip bottom>
			<template v-slot:activator="{ on, attrs }">
				<v-btn
					v-show="showExportButtons"
					v-on="on"
					x-small
					v-bind="attrs"
					color="secondary"
					class="ma-2 elevation-0"
					@click="exportToPdf"
				>
					<v-icon small>mdi-file-pdf</v-icon>
				</v-btn>
			</template>
			<span>Descargar pdf</span>
		</v-tooltip>
		<!-- export csv -->
		<v-tooltip bottom>
			<template v-slot:activator="{ on, attrs }">
				<v-btn
					v-show="showExportButtons"
					v-on="on"
					v-bind="attrs"
					x-small
					color="secondary"
					class="ma-2 elevation-0"
					@click="exportToCsv"
				>
					<v-icon small>mdi-file-delimited</v-icon>
				</v-btn>
			</template>
			<span>Descargar csv</span>
		</v-tooltip>
		<!-- export csv -->
		<v-tooltip color="warning" bottom>
			<template v-slot:activator="{ on, attrs }">
				<v-btn
					v-bind="attrs"
					v-on="on"
					outlined
					x-small
					color="primary"
					class="ma-2 elevation-0"
					@click="refreshData"
					dark
				>
					<v-icon small>mdi-reload</v-icon>
				</v-btn>
			</template>
			<span>Refrescar cronograma.</span>
		</v-tooltip>
	</div>
</template>

<script>
import Moment from 'moment';
import { mapGetters, mapActions, mapMutations } from 'vuex';
import { extendMoment } from 'moment-range';
let moment = extendMoment(Moment);

export default {
	name: 'AssistantButtons',
	props: {
		activities: {
			type: Array,
			required: true,
		},
	},
	computed: {
		showExportButtons() {
			return this.activities.length;
		},
		...mapGetters({
			selectedPlace: 'Lodging/selectedPlace',
			rangeDate: 'Lodging/rangeDate',
		}),
	},
	methods: {
		async refreshData() {
			this.getPersonsByAdmin();
			this.fetchLodgings(this.selectedPlace.value);
		},
		itsDue(date) {
			return moment(date).isBefore(moment().format());
		},
		async exportToPdf() {
			try {
				const pdf = await this.generatePdfReport({
					idPlace: this.selectedPlace.value,
					date: moment(this.rangeDate.start).format('DD-MM-YYYY'),
					activities: this.activities,
				});
				let blob = new Blob([pdf], { type: 'application/pdf' });
				let link = document.createElement('a');
				let toDay = new Date();
				link.href = window.URL.createObjectURL(blob);
				link.download =
					this.selectedPlace.text +
					' ' +
					this.selectedPlace.services[0].name +
					' ' +
					moment(toDay).format('MMMM YYYY') +
					'.pdf';
				link.click();
			} catch (error) {
				this.snackbar({
					content: error.message,
					color: 'error',
				});
			}
		},
		async exportToCsv() {
			try {
				const csv = await this.generateCsvReport({
					placeId: this.selectedPlace.value,
					date: moment(this.rangeDate.start).format('DD-MM-YYYY'),
					activities: this.activities,
				});
				let toDay = new Date();
				let blob = new Blob([csv], { type: 'text/csv' });
				let link = document.createElement('a');
				link.href = window.URL.createObjectURL(blob);
				link.download =
					this.selectedPlace.text +
					' ' +
					this.selectedPlace.services[0].name +
					' ' +
					moment(toDay).format('MMMM YYYY') +
					'.csv';
				link.click();
			} catch (error) {
				this.snackbar({
					content: error.message,
					color: 'error',
				});
			}
		},
		...mapActions({
			getPersonsByAdmin: 'Person/getPersonsByAdmin',
			fetchLodgings: 'Lodging/fetchLodgings',
			generateCsvReport: 'Lodging/generateCsvReport',
			generatePdfReport: 'Lodging/generatePdfReport',
		}),
		...mapMutations({ snackbar: 'Snackbar/showMessage' }),
	},
};
</script>
